import { Link } from "react-router-dom";
import {
  ArrowRight,
  CalendarCheck2,
  FileHeart,
  MessageSquareText,
  PackageCheck,
  UsersRound,
} from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const cards = [
  {
    title: "Neighbor intake",
    body: "Localized signup is ready for English and Spanish testing.",
    icon: FileHeart,
    to: "/connect",
    status: "Ready for feedback",
  },
  {
    title: "Profiles",
    body: "Search, matching, consent, language, and dual-entry boundaries.",
    icon: UsersRound,
    to: "/admin/profiles",
    status: "Core workflow",
  },
  {
    title: "Distributions",
    body: "Schedule service sessions, check in households, and measure people served.",
    icon: PackageCheck,
    to: "/admin/distributions",
    status: "Core workflow",
  },
  {
    title: "Events",
    body: "Lightweight household RSVP and attendance check-in.",
    icon: CalendarCheck2,
    to: "/admin/events",
    status: "Core workflow",
  },
  {
    title: "Communications",
    body: "Localized drafts and audience counts with delivery safely gated.",
    icon: MessageSquareText,
    to: "/admin/communications",
    status: "Send disabled",
  },
];

export function AdminOverview() {
  return (
    <div className="mx-auto max-w-6xl">
      <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
        <div>
          <Badge className="bg-secondary text-primary">
            Mountain View pilot
          </Badge>
          <h1 className="mt-4 text-3xl font-bold tracking-tight">
            Priority workflows
          </h1>
          <p className="mt-2 text-muted-foreground">
            The smallest complete system that can produce useful stakeholder
            feedback.
          </p>
        </div>
        <Link to="/" className="text-sm font-semibold text-primary">
          View neighbor site →
        </Link>
      </div>
      <div className="mt-8 grid gap-5 md:grid-cols-2">
        {cards.map(({ title, body, icon: Icon, to, status }) => (
          <Card key={title}>
            <CardHeader>
              <div className="flex items-start justify-between">
                <span className="grid h-11 w-11 place-items-center rounded-xl bg-secondary text-primary">
                  <Icon size={22} />
                </span>
                <Badge>{status}</Badge>
              </div>
              <CardTitle className="pt-4">{title}</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm leading-6 text-muted-foreground">{body}</p>
              <Link
                to={to}
                className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-primary"
              >
                Open workflow <ArrowRight size={15} />
              </Link>
            </CardContent>
          </Card>
        ))}
      </div>
      <Card className="mt-6 border-amber-200 bg-amber-50">
        <CardContent className="p-6">
          <strong>Feedback boundary</strong>
          <p className="mt-1 text-sm leading-6 text-amber-900/75">
            Validate household check-in, services recorded, event registration
            details, and message wording before adding volunteer scheduling
            depth, two-way inboxes, or passes.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
